import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RouterGuard } from './router-guard';

const routes: Routes = [
  {
    path: '', redirectTo: '/signin', pathMatch: 'full',
  },
  {
    path: 'main', loadChildren: () => import('./main/main.module').then(m => m.MainModule),
    canActivate: [RouterGuard],
    data: { breadcrumb: '대시보드' }
  },
  {
    path: 'signin', loadChildren: () => import('./sign-in/sign-in.module').then(m => m.SignInModule)
  },
  {
    path: 'access', loadChildren: () => import('./access/access.module').then(m => m.AccessModule),
    canActivate: [RouterGuard],
    canLoad: [RouterGuard],
    data: { breadcrumb: '출입관리' }
  },
  {
    path: 'device', loadChildren: () => import('./device/device.module').then(m => m.DeviceModule),
    canActivate: [RouterGuard],
    canLoad: [RouterGuard],
    data: { breadcrumb: '장치' }
  },
  {
    path: 'user', loadChildren: () => import('./user/user.module').then(m => m.UserModule),
    canActivate: [RouterGuard],
    canLoad: [RouterGuard],
    data: { breadcrumb: '사용자' }
  },
  {
    path: 'visit', loadChildren: () => import('./visit/visit.module').then(m => m.VisitModule),
    canActivate: [RouterGuard],
    canLoad: [RouterGuard],
    data: { breadcrumb: '방문증관리' }
  },
  {
    path: 'admin', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule),
    canActivate: [RouterGuard],
    canLoad: [RouterGuard],
    data: { breadcrumb: '관리자' }
  },
  {
    path: 'my-info', loadChildren: () => import('./my-info/my-info.module').then(m => m.MyInfoModule),
    canActivate: [RouterGuard],
    canLoad: [RouterGuard],
    data: { breadcrumb: '내정보' }
  },
  {
    path: 'key-management',
    redirectTo: 'admin/key-management',
    pathMatch: 'full',
  },
  {
    path: 'system-log',
    redirectTo: 'admin/system-log',
    pathMatch: 'full',
  },
  {
    path: '**', loadChildren: () => import('./error-page/error-page.module').then(m => m.ErrorPageModule),
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
